import React, { useCallback, useContext, useState, useMemo } from "react";
import { isEmpty, map, partial, pipe, values } from "ramda";
import styled from "styles/styled_components";

import Button, { ButtonColor } from "components/shared/button";
import Modal from "components/shared/modal";
import StyledScrollBox from "components/shared/scroll_box";
import StyledTextButton from "components/shared/text_button";

import PermalinkContext from "helpers/context/permalink";
import { ITemplatesKeyed } from "types/reducers";
import { RequestStatus } from "types/requests";
import { ITemplate } from "types/templates";

const StyledMarginItem = styled.li`
  margin: ${({ theme }) => `${theme.spacing.large} ${theme.spacing.medium};`};
`;

// @ts-ignore TODO please fix this error
const StyledListItem = styled(StyledMarginItem)`
  list-style: none;
  text-align: left;
`;

const StyledDeleteButton = styled(StyledTextButton)`
  float: right;
  font-size: inherit;
  &:hover:not(:disabled) {
    color: ${(props) => props.theme.colors.brandOrange50};
  }
`;

interface ISaveTemplateProps {
  onClose: () => void;
  deleteTemplate: (location: string, uuid: string) => void;
  status: RequestStatus;
  templates: ITemplatesKeyed;
}

export default function ManageTemplates({
  onClose,
  deleteTemplate,
  templates,
}: ISaveTemplateProps) {
  const permalink = useContext(PermalinkContext);
  // Track transient state of which template has been clicked (while waiting for API)
  const [deleting, setDeleting] = useState("");
  const onDelete = useCallback(
    (uuid: string) => {
      setDeleting(uuid);
      deleteTemplate(permalink, uuid);
    },
    [deleteTemplate, onClose]
  );

  const templateList = useMemo(() => {
    let listItems;
    if (isEmpty(templates)) {
      listItems = (
        <StyledMarginItem>
          You do not have any saved templates.
        </StyledMarginItem>
      );
    } else {
      listItems = pipe(
        // @ts-expect-error TODO please fix this error
        values,
        map(({ name, uuid }: ITemplate) => {
          return (
            <StyledListItem key={uuid}>
              {name}
              <StyledDeleteButton
                disabled={deleting === uuid}
                onClick={partial(onDelete, [uuid])}
              >
                Delete
              </StyledDeleteButton>
            </StyledListItem>
          );
        })
        // @ts-expect-error TODO please fix this error
      )(templates);
    }
    return <ul>{listItems}</ul>;
  }, [templates, onClose, deleting]);

  return (
    <Modal title="Manage Templates" onClose={onClose}>
      <StyledScrollBox>{templateList}</StyledScrollBox>
      <Button label="Cancel" buttonColor={ButtonColor.GRAY} onClick={onClose} />
    </Modal>
  );
}
